<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      :inputArr="inputArr"
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
      @addEvent="addEvent"
    />

    <!-- 列表 -->
    <my-table
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
      @click.native="testNative"
      @handleSelectionChange="handleSelectionChange"
    />

    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />

    <!-- 添加、修改组件 -->
    <my-dialog
      :isDialogShow.sync="isDialogShow"
      :operTitle="operTitle"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :rules="rules"
      :loading="loading"
      @submitForm="submitForm"
      @hook:mounted="doSomeThing"
    />
  </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import { customizationList } from "@/network/other/customization";
export default {
  mixins: [mixins],
  provide() {
    return {
      importType: "customization",
      initData: this.getInitData,
    };
  },
  watch: {
    tableData: {
      handler(val) {
        // console.log(val);
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        {
          name: "平台",
          prop: "type",
        },
		{
		  name: "安全币",
		  prop: "integral",
		},
		{
		  name: "价钱",
		  prop: "price",
		},
        {
          name: "操作",
          prop: "operation",
          operation: [
            { name: "编辑", clickFun: this.editCustomization, show: true },
            { name: "删除", clickFun: this.delCustomization, show: true },
          ],
        },
      ]),
      //筛选时文本框所需参数
      inputArr: [
        {
          name: "textName",
          defaultText: "请输入套餐名称",
        },
      ],
      //编辑时文本框所需参数
      operFormArr: [
        {
          name: "name",
          label: "套餐名称",
          defaultText: "请输入套餐名称",
        },
        {
          name: "tagNum",
          label: "标签数量",
          defaultText: "请输入标签数量",
        },
        {
          name: "recommendQty",
          label: "推荐数量",
          defaultText: "请输入推荐数量",
        },
        {
          name: "monthAmount",
          label: "一个月费用",
          defaultText: "请输入一个月费用",
        },
        {
          name: "threeAmount",
          label: "三个月费用",
          defaultText: "请输入三个月费用",
        },
        {
          name: "yearAmount",
          label: "一年费用",
          defaultText: "请输入一年费用",
        },
      ],
      //添加、编辑双向绑定值
      operForm: {
        id: "",
        name: "",
        tagNum: "",
        recommendQty: "",
        monthAmount: "",
        threeAmount: "",
        yearAmount: "",
      },
      //搜索参数
      searchParams: {
        timeOptions: "",
        textName: "",
      },
      // rules表单验证
      rules: {
        name: [
          {
            required: true,
            message: "请输入套餐名称",
            trigger: "blur",
          },
        ],
        tagNum: [
          {
            required: true,
            message: "请输入标签数量",
            trigger: "blur",
          },
        ],
        recommendQty: [
          {
            required: true,
            message: "请输入推荐数量",
            trigger: "blur",
          },
        ],
        monthAmount: [
          {
            required: true,
            message: "请输入一个月费用",
            trigger: "blur",
          },
        ],
        threeAmount: [
          {
            required: true,
            message: "请输入三个月费用",
            trigger: "blur",
          },
        ],
        yearAmount: [
          {
            required: true,
            message: "请输入一年费用",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getInitData();
  },
  methods: {
    getInitData() {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let params = {
        data: {
          name: this.searchParams.textName,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      customizationList(params).then((e) => {
        this.loading = false;
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
        }
      });
    },
    //添加、编辑
    submitForm(valid) {
      if (valid) {
        //根据类型不同调用不同的操作接口
        let interType = this.operTitle ? addRole : editRole;
        interType(this.operForm).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.isDialogShow = false;
            this.loading = false;
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      } else {
        return false;
      }
    },
    //搜索事件
    searchEvent() {
      this.getInitData();
    },
    //添加事件
    addEvent() {
      this.isDialogShow = true;
      this.operTitle = true;
      this.operForm = {}; //防止多次添加有上次添加的残留数据
    },
    //编辑事件
    editCustomization(item) {
      this.isDialogShow = true;
      this.operTitle = false;

      this.operForm = {
        id: item.id,
        name: item.name,
        tagNum: item.tagNum,
        recommendQty: item.recommendQty,
        monthAmount: item.monthAmount,
        threeAmount: item.threeAmount,
        yearAmount: item.yearAmount,
      };
    },
    //删除事件
    delCustomization(item) {
      this.$confirm("删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delRole(item.id).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //批量删除
    allDel() {
      let data = this.selectedData;
      if (data.length == 0) {
        this.$message.warning("请选择要操作的数据！");
        return;
      }
      this.$confirm("删除所选数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let delIds = [];
        delIds = data.map((e) => e.id);
        allDelRole({
          ids: delIds,
        }).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      });
    },
    //详情函数式组件关闭弹框
    closeDialog() {
      this.isDialogDetailShow = false;
    },
    //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
    testNative() {
      // console.log("native click");
    },
    //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
    doSomeThing() {
      // console.log('父组件监听到 mounted 钩子函数 ...');
    },
  },
};
</script>

<style scoped>
</style>

 
 